export const LOCAL_STORAGE = 'LOCAL_STORAGE'
export const SESSION_STORAGE = 'SESSION_STORAGE'
export const LOCAL_STORAGE_SELECTED_SET = 'selectedSet'
export const LOCAL_STORAGE_SELECTED_TOPICS = 'selectedTopics'
